import { isRemember } from "@/helper/RememberMe";
export default class StorageService {
    static getStorage() {
        return isRemember() ? localStorage : sessionStorage;
    }
    static setToStorage(key, data) {
        this.getStorage().setItem(key, JSON.stringify(data));
    }
    static setObjectToStorage(key, data) {
        this.getStorage().setItem(key, data);
    }
    static getFromStorage(key) {
        return this.getStorage().getItem(key);
    }
    static removeFromStorage(key) {
        this.getStorage().removeItem(key);
    }
    static listenStorage(callback) {
        window.addEventListener("storage", callback, false);
    }
}
